module.exports = __webpack_public_path__ + "static/media/motorA.8f02e8fc.svg";